// Hook para registrar shortcuts de teclado globales.
// Uso:
//   useKeyboardShortcuts([
//     { key: 'k', ctrlKey: true, handler: () => buscar() },
//     { key: 'Escape', handler: () => cerrar() },
//   ]);

import { useEffect } from 'react';

export function useKeyboardShortcuts(shortcuts) {
    useEffect(() => {
        const handler = (e) => {
            // e.key puede venir undefined en eventos sintéticos (password managers,
            // autofill, IME, dead keys). Si no hay key, no hay match posible.
            if (!e.key) return;
            for (const sc of shortcuts) {
                if (!sc || !sc.key) continue;
                // Evitar conflicto cuando está tipeando en input/textarea (salvo Escape)
                const target = e.target;
                const esInput = target && (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable);
                if (esInput && sc.key !== 'Escape' && !sc.ctrlKey && !sc.metaKey) continue;

                const matchKey = e.key === sc.key || e.key.toLowerCase() === sc.key.toLowerCase();
                const matchCtrl = !!sc.ctrlKey === (e.ctrlKey || e.metaKey);
                const matchShift = !!sc.shiftKey === e.shiftKey;
                const matchAlt = !!sc.altKey === e.altKey;

                if (matchKey && matchCtrl && matchShift && matchAlt) {
                    if (sc.preventDefault !== false) e.preventDefault();
                    sc.handler(e);
                    break;
                }
            }
        };
        window.addEventListener('keydown', handler);
        return () => window.removeEventListener('keydown', handler);
    }, [shortcuts]);
}

// Registro global de shortcuts — útil para showearlos en un dialog de ayuda
export const SHORTCUTS_GLOBALES = [
    { combo: 'Ctrl + K', desc: 'Abrir buscador de personas' },
    { combo: 'Ctrl + /', desc: 'Mostrar atajos disponibles' },
    { combo: 'Esc', desc: 'Cerrar modal o panel abierto' },
    { combo: 'Alt + P', desc: 'Ir a Perfil' },
    { combo: 'Alt + H', desc: 'Ir al Inicio' },
];
